import { render, staticRenderFns } from "./ParecerMedico.vue?vue&type=template&id=bb622b44&"
import script from "./ParecerMedico.vue?vue&type=script&lang=js&"
export * from "./ParecerMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports